import {
	CONSULTATION_KEY_TYPE,
	CONSULTATION_TARGET_KEY_TYPE,
	DEFAULT_TAX_ACCOUNTANT_NAME,
	RECOMMENDED_CUSTOMER_INFO,
	TaxAccountantNameModel
} from "@/shared/model";
import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "../../tax-corporation";

const schema = z.object({
	id: z.string(),
	editable: z.boolean(),
	department: z.string(),
	managerInformation: ManagerInformationModel.model,
	taxAccountantName: TaxAccountantNameModel.model,
	visitedAt: z.string(),
	wroteDate: z.string(),
	visitPurpose: CONSULTATION_KEY_TYPE.nullable(),
	visitPurposeDetail: CONSULTATION_TARGET_KEY_TYPE.nullable(),
	content: z.string().nullable(),
	files: z.array(z.string()).nullable(),
	recommendedCustomers: z.array(RECOMMENDED_CUSTOMER_INFO).nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const VisitHistoryModifyResModel = {schema, model};
export type IVisitHistoryModifyResModel = z.infer<typeof VisitHistoryModifyResModel.model>;

export const DEFAULT_VISIT_HISTORY_MODIFY_RES: IVisitHistoryModifyResModel = {
	id: "",
	editable: false,
	department: "",
	managerInformation: DEFAULT_MANAGER_INFORMATION,
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	visitedAt: "",
	wroteDate: "",
	visitPurpose: null,
	visitPurposeDetail: null,
	content: "",
	files: [],
	recommendedCustomers: []
};
